export default {"src":"/_next/static/media/header-image.bf48fed8.svg","height":900,"width":731};